@if (isVisible) {
  <div
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50"
    (click)="onBackdropClick($event)"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="title ? 'modal-title' : null"
  >
    <div
      class="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6"
      (click)="$event.stopPropagation()"
    >
      @if (title) {
        <h2
          id="modal-title"
          class="text-xl font-semibold mb-4 title-dynamic-theme"
        >
          {{ title }}
        </h2>
      }

      @if (message) {
        <p class="mb-6 text-base">
          {{ message }}
        </p>
      }

      <div class="flex gap-4 justify-end">
        <app-button
          buttonId="modal-cancel-button"
          [buttonText]="cancelButtonText"
          buttonType="button"
          [customClasses]="'px-6 py-2 border border-gray-300 rounded hover:bg-gray-50'"
          (buttonClick)="onCancel()"
        ></app-button>

        <app-button
          buttonId="modal-confirm-button"
          [buttonText]="confirmButtonText"
          buttonType="button"
          [customClasses]="'px-6 py-2 bg-primary text-white rounded hover:opacity-90'"
          (buttonClick)="onConfirm()"
        ></app-button>
      </div>
    </div>
  </div>
}
